import RegionChangerController from './RegionChangerController'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => {
  return {
    regionsData: state.REGIONS.regionsData,
    countriesData: state.REGIONS.countriesData,
    selectedRegionId: state.REGIONS.selectedRegionId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSelectedRegionId: selectedRegionId => dispatch(ReduxActions.setSelectedRegionId(selectedRegionId))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegionChangerController)
)



// WEBPACK FOOTER //
// ./src/modules/Controllers/RegionChanger/RegionChangerController/index.js